import { hillo } from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import VipUser from '@/model/dataLayer/api/Vip/VipUser'
import dayjs from 'dayjs'

const awardType = 'membership/award'
export const AwardClaimType = [{ label: 'OrderCount', value: 'OrderCount' }, { label: 'OrderAmount', value: 'OrderAmount' }, { label: 'ItemCount', value: 'ItemCount' }]

const entity = {
  name: {},
  status: {},
  claimType: {},
  pointClearAfterLastUsageDays: {},
  createTimestamp: {},
  lastUpdateAt: {},
  progressLinear: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  userId: {
    displayName: 'user',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          return (await VipUser.getList(true))
        },
        itemText: 'username',
        itemValue: 'userId'
      }
    }
  }
}
const config = {
  load: async function () {
    return (await hillo.get(cloudV2Url + awardType + '/progress/blId/' + GlobalConfig.blId, {})).map(it => {
      it.name = it.awardInfo.awardDisplayDetails.name
      it.claimType = it.awardInfo.claimType
      it.pointClearAfterLastUsageDays = it.awardInfo.pointClearAfterLastUsageDays
      it.createTimestamp = dayjs(it.createTimestamp).format('YYYY-MM-DD HH:mm:ss')
      it.lastUpdateAt = dayjs(it.lastUpdateAt).format('YYYY-MM-DD HH:mm:ss')
      it.awardMax = it.awardInfo.awardMax
      return it
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
